import React from "react";

import { Icon, IconProps } from "../";

export const MccmLineCommentIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.45 22.5H12C17.79 22.5 22.5 17.79 22.5 12C22.5 6.21 17.79 1.5 12 1.5C6.21 1.5 1.5 6.21 1.5 12C1.5 14.14 2.14 16.16 3.36 17.9L2.08 19.18C1.31 19.95 1.31 21.15 2.08 21.92C2.47 22.31 2.92 22.5 3.45 22.5ZM12 20.5H3.59H3.58L5.39 18.69C5.75 18.32 5.78 17.74 5.45 17.34C4.18 15.81 3.5 13.96 3.5 12C3.5 7.31 7.31 3.5 12 3.5C16.69 3.5 20.5 7.31 20.5 12C20.5 16.69 16.69 20.5 12 20.5ZM7.44995 13.1301C6.76995 13.1301 6.31995 12.6801 6.31995 12.0001C6.31995 11.3201 6.76995 10.8701 7.44995 10.8701C8.12995 10.8701 8.57995 11.3201 8.57995 12.0001C8.57995 12.6801 8.12995 13.1301 7.44995 13.1301ZM10.88 12.0001C10.88 12.6801 11.33 13.1301 12.01 13.1301C12.69 13.1301 13.14 12.6801 13.14 12.0001C13.14 11.3201 12.69 10.8701 12.01 10.8701C11.33 10.8701 10.88 11.3201 10.88 12.0001ZM16.5699 13.1301C15.8899 13.1301 15.4399 12.6801 15.4399 12.0001C15.4399 11.3201 15.8899 10.8701 16.5699 10.8701C17.2499 10.8701 17.6999 11.3201 17.6999 12.0001C17.6999 12.6801 17.2499 13.1301 16.5699 13.1301Z"
      />
    </Icon>
  );
};
